module.exports = __webpack_public_path__ + "static/media/back_ic.c72a8d9d.svg";